import _extends from '@babel/runtime/helpers/extends';
import React__default, { useContext, useCallback } from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../../3rdPartyModules/_react-aria/utils/dist/mergeProps-DMtmc2Zw.js';
import { S as SelectOptionDisplayName } from '../utils/displayNames-DWYGtsUp.js';
import { d as defaultValueSerializer } from '../utils/defaultValueSerializer-BrPGuJ5m.js';
import { S as SelectListContext } from '../SelectListContext-8rVkHKcx.js';
import { R as RenderWrapper, S as SelectButton, a as StandaloneSelectButton } from './SelectOption.styles-DvKNyAYi.js';
import { T as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { n as noop } from '../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const SelectItem = ({
  className,
  /**
   * DEPRECATE IN STORM 4.X: This should only be read from SelectListContext.
   */
  onClick,
  children,
  value,
  /**
   * DEPRECATE IN STORM 4.X: This should only be read from SelectListContext.
   */
  selected,
  /**
   * DEPRECATE IN STORM 4.X: This should only be read from SelectListContext.
   */
  noWrap,
  renderStart,
  renderEnd,
  /**
   * DEPRECATE IN STORM 4.X: This should only be read from SelectListContext.
   */
  focused,
  renderAfter,
  disabled,
  taktId,
  taktValue,
  ...rest
}) => {
  const handleClick = useCallback(event => {
    if (typeof onClick === 'function') {
      onClick === null || onClick === void 0 || onClick(value, event);
    }
  }, [onClick, value]);
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  if (value === undefined || value === null) return null;
  const selectItemButtonProps = {
    ...rest,
    selected,
    noWrap,
    disabled,
    type: 'button',
    role: 'option',
    'aria-selected': selected || focused,
    className,
    value: defaultValueSerializer(value),
    onClick: handleClick
  };
  if (renderAfter && typeof renderAfter === 'function') {
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('select-item-button')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement(RenderWrapper, {
      selected: selected,
      disabled: disabled,
      noWrap: noWrap,
      $focused: isFocusVisible
    }, /*#__PURE__*/React__default.createElement(SelectButton, $3ef42575df84b30b$export$9d1611c77c2fe928(getDataTaktAttributes(), selectItemButtonProps, focusProps), renderStart && renderStart(), children, renderEnd && renderEnd()), renderAfter()));
  }
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('select-item-button')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(StandaloneSelectButton, _extends({}, $3ef42575df84b30b$export$9d1611c77c2fe928(getDataTaktAttributes(), selectItemButtonProps, focusProps), {
    $focused: isFocusVisible
  }), renderStart && renderStart(), children, renderEnd && renderEnd()));
};
SelectItem.propTypes = {
  className: PT.string,
  onClick: PT.func,
  value: PT.any,
  selected: PT.bool,
  children: PT.node,
  noWrap: PT.bool,
  renderStart: PT.func,
  renderEnd: PT.func,
  focused: PT.bool
};
SelectItem.defaultProps = {
  className: '',
  onClick: noop,
  value: undefined,
  selected: false,
  children: null,
  noWrap: false,
  renderStart: undefined,
  renderEnd: undefined,
  focused: false,
  renderAfter: undefined
};
const SelectOption = /*#__PURE__*/styled(SelectItem).attrs(({
  focused,
  noWrap,
  onClick,
  selected,
  theme,
  value,
  ...rest
}) => {
  const {
    focusedValue,
    noWrap: selectListNoWrap,
    onClick: selectListOnClick,
    selectedValue,
    afterOnSelect
  } = useContext(SelectListContext);
  const handleClick = (...args) => {
    if (selectListOnClick) {
      selectListOnClick(...args);
    } else if (onClick) {
      onClick(...args);
    }
    if (afterOnSelect) {
      afterOnSelect();
    }
  };
  let isSelected = selected;
  let isFocused = focused;
  if (selectedValue && value) {
    isSelected = value === selectedValue;
  }
  if (focusedValue && value) {
    isFocused = value === focusedValue;
  }
  return {
    focused: isFocused,
    noWrap: selectListNoWrap || noWrap,
    onClick: handleClick,
    selected: isSelected,
    value,
    ...rest
  };
}).withConfig({
  componentId: "sc-storm-ui-30060407__sc-1rm1drt-0"
})([""]);
SelectOption.displayName = SelectOptionDisplayName;
SelectOption.propTypes = {
  onClick: PT.func,
  value: PT.any,
  selected: PT.bool,
  children: PT.node,
  noWrap: PT.bool,
  renderStart: PT.func,
  renderEnd: PT.func,
  focused: PT.bool
};

export { SelectOption as S };
//# sourceMappingURL=SelectOption-C9vITyx4.js.map
